import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthStore {
  token: string | null;
  customerId: number | null;
  customerName: string | null;
  isAuthenticated: boolean;
  isAdmin: boolean;
  login: (token: string, customerId: number, name: string, isAdmin: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      token: null,
      customerId: null,
      customerName: null,
      isAuthenticated: false,
      isAdmin: false,

      login: (token, customerId, name, isAdmin) => {
        localStorage.setItem('store_token', token);
        set({ token, customerId, customerName: name, isAuthenticated: true, isAdmin });
      },

      logout: () => {
        localStorage.removeItem('store_token');
        set({ token: null, customerId: null, customerName: null, isAuthenticated: false, isAdmin: false });
      },
    }),
    { name: 'babychic-auth' }
  )
);
